import {injectable} from "inversify";
import {ShopService} from "@/services/shop-service";
import {TabbedPanel} from "@/scenes.ui/tabbed-panel";
import {Tr} from "@/i18n/i18n";
import ShopStore from "@/store/shop";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {HeroExchangeOptions, ShopCreature} from "@/store/shop/types";
import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {CreatureUtils} from "@/utils/creature-utils";
import {MythHeroPanel} from "@/scenes.ui/myth-hero-panel";
import {SellCreaturePanel} from "@/scenes.ui/sell-creature-panel";
import SoundUtils from "@/utils/sound-utils";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {GameState} from "@/constants/game-state";
import {NewCreaturePanel} from "@/scenes.ui/new-creature-panel";
import OnceCaller from "@/utils/once-caller";
import {HeroShopService} from "@/services/hero-shop-service";
import Container = Phaser.GameObjects.Container;

@injectable()
export class HeroTownShopService extends ShopService {

    protected createTabbedPanel(): TabbedPanel {
        let self = this;
        return new TabbedPanel(this.scene!, this.canvas!, Tr('heroes.gate'), ['bank', 'heroes'],
            [Tr('bank'), Tr('geroi')], [true, true], this.selectSound, (tabId: string) => {
                if (tabId === 'bank') {
                    this.populateBankTab();
                } else if (tabId === 'heroes') {
                    this.populateHeroesTab();
                }
            }, () => {}, () => self.closeCallback());
    }

    protected populateHeroesTab(): void {
        let self = this;

        let player = PlayerStore.getPlayer()!;
        this.setupHeroAgitations(player);

        ShopStore.fetchHeroExchangeOptions('hero_town').then((eo: HeroExchangeOptions) => {
            const shopCreatures: ShopCreature[] = eo.shopCreatures;
            let panels: Container[] = [];
            let self = this;

            let panelY = 0;

            panels.push(...HeroShopService.getTopTextsByTabId(this.scene!, this.canvas!));

            shopCreatures.forEach(sc => {
                let classText = CreatureUtils.getClassName(sc.creature.warriorClass);
                if (!classText) {
                    return;
                }

                let scp = new MythHeroPanel(this.scene!, 0, panelY, sc, self.statClickCallback, () => {
                    let sellPanel: SellCreaturePanel = new SellCreaturePanel(self.scene!, self.canvas!, sc,
                        eo.myCreaturePrices, self.awardSound, (checkedIds: number[], price: number) => {
                            sellPanel.close();
                            if (PlayerStore.getPlayer().mithril < price) {
                                SoundUtils.play(self.levelUpSound);
                                this.tabbedPanel.goToTab('bank');
                                new FeedbackPanel(self.scene!, Tr('ne.hvataet.izumrudov'), self.tabbedPanel!, false).show();
                            } else {
                                GameState.REQUEST_REFRESH_NAV_PANEL = true;
                                ShopStore.exchangeCreature(sc.id, checkedIds).then(() => {
                                    this.tabbedPanel.closePanel();
                                    SoundUtils.play(self.awardSound);
                                    sc.creatures.forEach(c => {
                                        new NewCreaturePanel(self.scene!, self.canvas!, c).openAnimated();
                                    });
                                });
                            }
                        });
                    sellPanel.openAnimated();
                });

                panels.push(scp);
                panelY += ShopCreaturePanel.HEIGHT;
            });

            this.tabbedPanel.supplyChildren('heroes', panels);
        });
    }

    protected getFetchHeroesAction(): () => Promise<void> {
        return ShopStore.fetchHeroTownShopCreatures;
    }

    protected setupHeroAgitations(player: Player) {
        this.tabbedPanel.setAgitationText(Tr('buy.unique.hero.from.castle'));
    }
}
